import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { LoginService } from 'src/app/Services/login.service';
import { ETipoLogin } from 'src/app/Models/Enumeradores/tipo-login.model';

@Injectable()
export class AdminGuard implements CanActivate {

    constructor(private loginService: LoginService, private rota: Router, private activatedRoute: ActivatedRoute) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.loginService.estaLogado() && this.loginService.obterTipoUsuario() === ETipoLogin.GSI) {
            return true;
        }

        this.rota.navigate(['pagina-nao-encontrada']);
        return false;
    }
}